<div class="header-bg">

  @if (showLogo) {
    <img class="company-logo" [src]="logoUrl" alt="logo" />
  }

  <button class="theme-toggle" (click)="themeService.toggle()" [title]="themeService.isDark ? 'Light mode' : 'Dark mode'">
    <i [class]="themeService.isDark ? 'fas fa-sun' : 'fas fa-moon'"></i>
  </button>

</div>
